<template>
  <div id="app" v-cloak>
    <main class="layout">
      <Layout>
        <Header></Header>
        <Content>
          <Card>
            <div style="min-height: 500px">
              <router-view :key="componentKey" />
            </div>
          </Card>
        </Content>
        <Footer class="text-center">Copyrights © 2021. All rights reserved by David</Footer>
      </Layout>
      <Loading v-if="isLoading"></Loading>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Loading from "@/components/Loading"

export default {
  name: "App",
  components: {
    Header,
    Loading,
  },
  data() {
    return {
      componentKey: 0,
    }
  },
  methods: {
    reload() {
      this.componentKey++
    },
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading()
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 80%;
  margin-left: 10%;
}
@media (max-width: 768px) {
  #app {
    width: 100%;
    margin-left: 0;
  }
}
.layout {
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
</style>
